import React from 'react';
import { Container, Dropdown, Navbar } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import Form from 'react-bootstrap/Form';
import { useColorMode } from '../contexts/ColorModeContext';
import type { IUser } from '../models/auth';
import SearchBar from '../search/search-bar/SearchBar';

export default function AuthenticatedNavbar(props: {
  user: IUser;
  navbarBrandAddon?: React.ReactNode;
  onNavToggle: () => void;
  navToggleAriaExpanded: boolean;
}): React.ReactElement {
  const { user, navbarBrandAddon, onNavToggle, navToggleAriaExpanded } = props;
  const { mode, toggleColorMode } = useColorMode();

  return (
    <Navbar bg="dark" variant="dark" expand={false} className="shadow-sm flex-shrink-0">
      <Container fluid className="d-flex align-items-center gap-2">
        <button
          type="button"
          className="navbar-toggler border-secondary fs-6"
          onClick={onNavToggle}
          aria-label="Toggle navigation"
          aria-expanded={navToggleAriaExpanded}
          aria-controls="app-side-nav">
          <span className="navbar-toggler-icon" />
        </button>
        <Navbar.Brand
          as={NavLink}
          to="/"
          className="mb-0 d-inline-flex align-items-center gap-2">
          <span>Relcore</span>
          {navbarBrandAddon}
        </Navbar.Brand>
        <div className="ms-auto d-flex flex-wrap align-items-center gap-2">
          <SearchBar forDarkNavbar />
          <Dropdown align="end">
            <Dropdown.Toggle
              variant="link"
              className="text-light text-decoration-none small py-0 px-2 border-0 shadow-none d-flex align-items-center"
              id="authenticated-user-menu">
              <span className="text-truncate" style={{ maxWidth: '14rem' }}>
                {user.firstName} {user.lastName}
              </span>
            </Dropdown.Toggle>
            <Dropdown.Menu variant="dark">
              <Dropdown.Item as="div" className="d-flex align-items-center gap-2">
                <i className="fas fa-sun fa-fw small" />
                <Form.Check
                  type="switch"
                  id="dark-mode-toggle"
                  checked={mode === 'dark'}
                  onChange={toggleColorMode}
                  label=""
                  aria-label="Toggle dark mode"
                  className="mb-0"
                />
                <i className="fas fa-moon fa-fw small" />
              </Dropdown.Item>
              <Dropdown.Divider />
              <Dropdown.Item as={NavLink} to="/logout">
                <i className="fas fa-sign-out-alt me-2" aria-hidden />
                Log out
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </Container>
    </Navbar>
  );
}
